import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Checkbox,
    Typography,
    FormControlLabel,
    Grid,
    TextField,
} from '@mui/material';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState, RichUtils  } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';

import * as footerActions from '../../../store/actions/footer';
import * as Styled from '../../../components/styled-components/Campaign';
import appConfig from '../../../config/appConfig';
import RadioButtonGroup from '../../../components/RadioButtonGroup';
import ButtonComponent from '../../../components/ButtonGroup';

const ErrorStyle = {
    color: "red",
    display: 'flex',
    marginTop: '5px'
}

const textboxCss = {
    border: `1px solid ${appConfig.colors.darkblue}`,
    borderRadius: "4px",
    outline: "none",
    '&.MuiFormControl-root': {
        margin: "0"
    },
    '&.MuiTextField-root': {
        backgroundColor: '#fff'
    },
    '& .MuiInputBase-input': {
        backgroundColor: '#fff',
        fontSize: 16,
        fontFamily: appConfig.fontfamily,
        padding: "10px 14px",
        borderRadius: "4px",
        outline: "none",

    },
    '& .MuiOutlinedInput-root': {
        padding: '0',
    }
};

const EditFooterConfiguration = ({ showFooterConfigurations, footerConfig, updateFooter, footerConfigs }) => {
    const filters = ['EN', 'ES', 'PT', 'VI', 'HT', 'ZH'];
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [isDefaultConfig, setIsDefaultConfig] = useState(footerConfig?.defaultConfigFlag ? 'Yes' : 'No');
    const [editorStateFooter, setEditorStateFooter] = useState(
            { 
                'en' : EditorState.createEmpty(), 'es' : EditorState.createEmpty(),
                'pt' : EditorState.createEmpty(), 'vi' : EditorState.createEmpty(),
                'ht' : EditorState.createEmpty(), 'zh' : EditorState.createEmpty()
            }
        );
    const [contentFooter, setContentFooter] = useState();
    const editorRefFooter = useRef();
    
    const [assignEnglishToOthers, setAssignEnglishToOthers] = useState(false);
    const [selectedLang, setSelectedLang] = useState("EN");
    // const [isFormSubmit, setIsFormSubmit] = useState(false);
    useEffect(() => {
        let tempEditorState = {};
        let tempContentFooter = {};
        footerConfig?.translations?.forEach((translation)=> {
            const footerContentBlock = htmlToDraft(translation?.content?.replace(/<[^/>][^>]*><\/[^>]+>/gim, ""));
            if (footerContentBlock) {
                const footerContent = ContentState.createFromBlockArray(footerContentBlock.contentBlocks);
                const footerEditor = EditorState.createWithContent(footerContent);
                tempEditorState = {...tempEditorState, [translation.languageCode]:  footerEditor};
                tempContentFooter = {...tempContentFooter, [translation.languageCode] : draftToHtml(convertToRaw(footerEditor.getCurrentContent()))};
            }
        });
        setEditorStateFooter(tempEditorState);
        setContentFooter(tempContentFooter);
    }, [])

    useEffect(() => {
        if(assignEnglishToOthers) {
            let tempEditorState = editorStateFooter;
            let tempContentFooter = contentFooter;
            filters.forEach((lang)=> {
                tempEditorState = {...tempEditorState, [lang.toLowerCase()]: tempEditorState.en};
                tempContentFooter = {...tempContentFooter, [lang.toLowerCase()] : tempContentFooter.en};
            }
            );
            setEditorStateFooter(tempEditorState);
            setContentFooter(tempContentFooter);
        }
    }, [assignEnglishToOthers])

    useEffect(() => {
        if(Object.keys(footerConfigs?.editFooterData).length > 0) {
            showFooterConfigurations();
        }
    }, [footerConfigs?.editFooterData])

    const filterHandleChange = (e) => {
        if (e.target.textContent) {
            setSelectedLang(e.target.textContent);
        }
    }

    const handleEditorChangeFooter = (state) => {
        setEditorStateFooter({...editorStateFooter, [selectedLang.toLowerCase()]: state});
        setContentFooter( {...contentFooter, [selectedLang.toLowerCase()] : `<div>${draftToHtml(convertToRaw(editorStateFooter[selectedLang.toLowerCase()].getCurrentContent()))}</div>`});
    }

    const uploadFileCallback = (file) => {
        return new Promise(
            (resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.addEventListener('load', () => {
                    resolve({ data: { link: reader.result } });
                });
            }
        );
    }

    const onSubmit = () => {
        const tempFooterConfig ={
            ...footerConfig,
            defaultConfigFlag: isDefaultConfig === 'Yes',
            sectionConfiguration: contentFooter.en,
            translations: [                
                {
                    ...footerConfig?.translations.find(e=>e.languageCode === 'en'),
                    content: contentFooter.en,
                },
                {
                    ...footerConfig?.translations.find(e=>e.languageCode === 'es'),
                    content: contentFooter.es,
                },
                {
                    ...footerConfig?.translations.find(e=>e.languageCode === 'pt'),
                    content: contentFooter.pt,
                },
                {
                    ...footerConfig?.translations.find(e=>e.languageCode === 'vi'),
                    content: contentFooter.vi,
                },
                {
                    ...footerConfig?.translations.find(e=>e.languageCode === 'zh'),
                    content: contentFooter.zh,
                },
            ]
        }        
        updateFooter(tempFooterConfig);
    }

    const handleContentChange = () => {
        setIsDefaultConfig(isDefaultConfig  === 'Yes' ? 'No' : 'Yes');
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6} lg={6} md={6}>
                    <h1 className='page-heading' ><b>Edit Footer Configuration</b></h1>
                </Grid>
                <Grid item xs={6} xl={6} lg={6} md={6}>
                    <div className='text-align-right'>
                        <Styled.CampaignButton
                            className='text-trans-none'
                            variant="contained"
                            onClick={showFooterConfigurations}
                        >
                            Footer Configurations
                        </Styled.CampaignButton>
                    </div>
                </Grid>
            </Grid>
            <hr className='blue-border' />
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid item md={7} xl={7} lg={7} xs={12} sm={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1 }}>Footer Configuration Name (Required)</Typography>
                            <TextField
                                {...register('name')}
                                margin="normal"
                                defaultValue={footerConfig?.name}
                                id="name"
                                sx={textboxCss}
                                fullWidth
                                inputProps={{ "aria-label": "footer name" }}
                                disabled
                            />
                        </div>
                        {errors?.name?.type === "required" && <span style={ErrorStyle}>Please enter Footer Configuration name.</span>}
                        {errors?.name?.type === "maxLength" && (<span style={ErrorStyle}>Footer Configuration name cannot exceed 80 characters</span>)}
                    </Grid>

                    <Grid item md={7} xl={7} lg={7} sm={12}>
                        <div >
                            <Typography component="p" sx={{ mb: 1 }} className="inline-blk">Footer Configuration Code (Required)</Typography>
                            <Typography component="p" sx={{ mb: 1 }} className="inline-blk flt-r">Must be 6 characters</Typography>
                            <TextField
                                {...register('code')}
                                margin="normal"
                                id="code"
                                defaultValue={footerConfig?.code}
                                sx={textboxCss}
                                fullWidth
                                inputProps={{ "aria-label": "footer code" }}
                                disabled
                            />
                        </div>
                        {errors?.code?.type === "required" && <span style={ErrorStyle}>Please enter Footer Configuration code.</span>}
                        {errors?.code?.type === "pattern" && (<span style={ErrorStyle}>Special characters not allowed.</span>)}
                        {errors?.code?.type === "maxLength" && (<span style={ErrorStyle}>Footer Configuration code must be 6 characters</span>)}
                        {errors?.code?.type === "minLength" && (<span style={ErrorStyle}>Footer Configuration code must be 6 characters</span>)}
                    </Grid>
                    <Grid item md={7} xl={7} lg={7} sm={12}>
                        <Typography component="p" sx={{ mb: 1 }} className="inline-blk">Set as default Footer Configuration?</Typography>
                        {!footerConfig?.defaultConfigFlag && <Typography component="p" sx={{ mb: 1, fontSize: '14px' }} className="inline-blk">(Overrides current default Footer Configuration)</Typography>}
                            <RadioButtonGroup
                                className={['create-using-account-radio', isDefaultConfig].join(' ')}
                                header=' '
                                defaultValue={isDefaultConfig}
                                labels={['Yes', 'No']}
                                handleChange={handleContentChange}
                                disabled={footerConfig?.defaultConfigFlag}
                            />
                    </Grid>
                    <Grid item md={12} xl={12} lg={12} sm={12}>
                        <Typography component="p" className="inline-blk">Footer Content</Typography>
                        <br/>
                        <br/>
                        <FormControlLabel
                            key='footerSetEnglish'
                            sx={[assignEnglishToOthers ? appConfig.checkboxStyleChecked : appConfig.checkboxStyle, appConfig.wFit]}
                            control={
                                <Checkbox
                                    sx={assignEnglishToOthers ? { color: appConfig.colors.white } : { color: appConfig.colors.darkblue }}
                                    checked={assignEnglishToOthers}
                                    onChange={() => { setAssignEnglishToOthers(!assignEnglishToOthers) }}
                                />
                            }
                            label='Apply English Footer content for other languages'
                        />
                        <div className='flt-r'><ButtonComponent filters={filters} activeFilter={selectedLang} onClick={filterHandleChange} /></div>
                    </Grid>
                    <Grid item md={12} xl={12} lg={12} sm={12}>
                        <Editor
                            tabIndex={0}
                            handlePastedText={() => false}
                            ref={editorRefFooter}
                            editorState={editorStateFooter[selectedLang.toLowerCase()]}
                            toolbar={
                                {
                                    image: { urlEnabled: true, uploadEnabled: true, previewImage: true, inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg', uploadCallback: uploadFileCallback },
                                    fontFamily: {
                                        options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'Source Sans Pro'],
                                    },
                                }}
                            editorStyle={{ border: "1px solid #ccc", height: "200px", padding: "15px" }}
                            toolbarStyle={{ border: "1px solid #ccc", paddingRight: "10%" }}
                            onEditorStateChange={(state) => { handleEditorChangeFooter(state) }}
                            handleKeyCommand={(command) => {
                            const newState = RichUtils.handleKeyCommand(editorStateFooter[selectedLang.toLowerCase()], command)                            
                                if (newState) {
                                    handleEditorChangeFooter(newState)
                                    return true;
                                }
                                return false;
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
                        <hr className='blue-border' />
                    </Grid>
                    <Grid container spacing={1} sx={{ marginLeft: "10px" }}>
                        <Grid item xs={12} sm={4} xl={1.5} lg={1.5} md={1.5}>
                            <Styled.CancelButton
                                variant="outlined"
                                sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: '100%', height: "50px" }}
                                onClick={showFooterConfigurations}
                            >
                                Cancel
                            </Styled.CancelButton>
                        </Grid>
                        <Grid item xs={12} sm={8} xl={5.6} lg={5.6} md={5.6}>
                            <Styled.CampaignButton
                                type='submit'
                                variant="contained"
                                sx={{ mt: 3, fontFamily: appConfig.fontfamily, textTransform: 'capitalize', width: '100%', height: "50px" }}
                            >
                                Update
                            </Styled.CampaignButton>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </div>
    );
}

EditFooterConfiguration.propTypes = {
    footerConfig: PropTypes.object.isRequired,
    footerConfigs: PropTypes.object.isRequired,
    showFooterConfigurations: PropTypes.func.isRequired,
    updateFooter: PropTypes.func.isRequired
}
const mapStateToProps = (state) => ({footerConfigs: state.footer})

const mapDispatchToProps = (dispatch) => {
    return {
        updateFooter: (data) => dispatch(footerActions.editFooter(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditFooterConfiguration);